import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, STRING, UUID, ITEM, COLLECTION, NUMBER } from '@/plugins/sdk/fields'
import AccountCarrierSetting from '@/plugins/sdk/resources/Account/CarrierSetting'
import CarrierService from '@/plugins/sdk/resources/Carrier/Service'
import FuelGroup from '@/plugins/sdk/resources/Fuel/Group'
import Zone from '@/plugins/sdk/resources/Dictionary/Zone'
import CarrierContact from '@/plugins/sdk/resources/Carrier/Contact'
import Time from './Carrier/Time'
import Seed from './Carrier/Tracking/Seed'
import Connection from './Connection'
import CarrierGroup from './Commercial/CarrierGroup'

export default class extends Resource {
  static name = 'carrier'
  static label = 'name'

  static get fields () {
    return {
      id: new UUID(),
      reference: new STRING(),
      name: new STRING(),
      enabled: new BOOLEAN(),
      label_template: new STRING(),
      con_template: new STRING(),
      edi_template: new STRING(),
      inv_template: new STRING(),
      pickup_template: new STRING(),
      tracking_template: new STRING(),
      tracking_available: new BOOLEAN(),
      print_label: new BOOLEAN(),
      print_connote: new BOOLEAN(),
      default_zone_parent: new BOOLEAN(),
      con_length: new STRING(),
      manifest_length: new STRING(),
      chainit: new STRING(),
      tracking_type: new STRING(),
      transfer_type: new BOOLEAN(),
      pickup_type: new BOOLEAN(),
      pickup_cutoff: new STRING(),
      full_name: new STRING(),
      address: new STRING(),
      town: new STRING(),
      postcode: new STRING(),
      state: new STRING(),
      phone: new STRING(),
      terms: new STRING(),
      edi_acc_req: new BOOLEAN(),
      edi_sysid_req: new BOOLEAN(),
      edi_siteid_req: new BOOLEAN(),
      edi_accepts_rtp: new BOOLEAN(),
      config_con_prefix_req: new BOOLEAN(),
      config_con_prefix_def: new STRING(),
      config_con_min_def: new STRING(),
      config_con_max_def: new STRING(),
      config_man_prefix_req: new BOOLEAN(),
      config_man_prefix_def: new STRING(),
      config_man_min_def: new STRING(),
      config_man_max_def: new STRING(),
      config_edi_sysid: new STRING(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME(),
      account_carrier_settings: new COLLECTION(AccountCarrierSetting),
      carrier_services: new COLLECTION(CarrierService),
      default_fuel_group: new ITEM(FuelGroup),
      default_service: new ITEM(CarrierService),
      grouped_location_carrier_zones: new COLLECTION(Zone),
      contacts: new COLLECTION(CarrierContact),
      pickup_contacts: new COLLECTION(CarrierContact),
      times: new COLLECTION(Time),
      seeds: new COLLECTION(Seed),
      edi_connection: new ITEM(Connection),
      tracking_connection: new ITEM(Connection),
      tracking_transformer_template: new STRING(),
      tracking_import_template: new STRING(),
      carrier_supports_gps_tracking: new BOOLEAN(),
      carrier_supports_run_sheets: new BOOLEAN(),
      carrier_pod_type: new BOOLEAN(),
      supports_item_tracking: new BOOLEAN(),
      carrier_tracking_pod_is_delivery_scan: new BOOLEAN(),
      carrier_tracking_link: new STRING(),
      carrier_tracking_notes: new STRING(),
      configuration_notes: new STRING(),
      validation_template: new STRING(),
      supports_residential: new BOOLEAN(),
      quote_template: new STRING(),
      carrier_group: new ITEM(CarrierGroup),
      supports_international: new BOOLEAN(),
      pickup_hold_on_creation: new BOOLEAN(),
      pickup_hold_if_same_day: new BOOLEAN(),
      third_party_pays: new BOOLEAN(),
      creates_consignment_externally: new BOOLEAN(),
      edi_transformer_template: new STRING(),
      edi_exporter_template: new STRING(),
      carrier_tier: new NUMBER(),
      logo_url: new STRING()
    }
  }

  static get sortables () {
    return [
      { field: 'name', label: 'Name' },
      { field: 'created_at', label: 'Created Date' },
      { field: 'updated_at', label: 'Updated Date' },
      { field: 'enabled', label: 'Enabled' }
    ]
  }
}
